import { Row, Col } from "antd"
import { useEffect, useRef } from "react"
import ReviewItemCard from "./ReviewItemCard"
import { useSelector, useDispatch } from "react-redux"
import { isLastPage } from "helpers/pagination"
import { useParams } from "react-router-dom"
import { getGuideReviews } from "store/guide-profile"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const ReviewItemList = ({ sort, searchTerm }) => {
  const { data, loading } = useSelector((store) => store.guideProfile?.reviews)
  const { reviews } = data || {}
  const { slug } = useParams()
  const dispatch = useDispatch()
  const containerRef = useRef(null)

  const handleLoadMore = () => {
    if (loading) return
    const params = {
      page: (data?.metadata?.page || 1) + 1,
      per_page: 10,
      review_mode: true,
      ...(sort && { sort_by: sort }),
      search: searchTerm
    }
    dispatch(getGuideReviews(slug, params))
  }

  const handleScroll = (e) => {
    if (loading || isLastPage(data?.metadata)) return
    const el = e.currentTarget
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 200) {
      handleLoadMore()
    }
  }

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    if (loading || isLastPage(data?.metadata)) return
    const notScrollable = el.scrollHeight <= el.clientHeight + 1
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200
    if (notScrollable || nearBottom) handleLoadMore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviews?.length, data?.metadata?.page, loading])

  return (
    <div ref={containerRef} className={styles.reviewList} onScroll={handleScroll}>
      <Row gutter={[16, 16]}>
        {reviews?.map((review) => (
          <Col xs={24} lg={12} key={review.id}>
            <ReviewItemCard review={review} />
          </Col>
        ))}
      </Row>
    </div>
  )
}

ReviewItemList.propTypes = {
  sort: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired
}

export default ReviewItemList
